"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LegacyMultiSelectListItem = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2021 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var react_intl_1 = require("react-intl");
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var noop_1 = tslib_1.__importDefault(require("lodash/noop"));
var util_1 = require("@gooddata/util");
/**
 * @internal
 * @deprecated This component is deprecated use MultiSelectListItem instead
 */
var LegacyMultiSelectListItem = /** @class */ (function (_super) {
    tslib_1.__extends(LegacyMultiSelectListItem, _super);
    function LegacyMultiSelectListItem(props) {
        var _this = _super.call(this, props) || this;
        _this.handleSelect = function () {
            _this.props.onSelect(_this.props.source);
        };
        _this.handleMouseOver = function () {
            _this.props.onMouseOver(_this.props.source);
        };
        _this.handleMouseOut = function () {
            _this.props.onMouseOut(_this.props.source);
        };
        _this.handleOnly = function (ev) {
            ev.stopPropagation();
            _this.props.onOnly(_this.props.source);
        };
        _this.handleSelect = _this.handleSelect.bind(_this);
        _this.handleMouseOver = _this.handleMouseOver.bind(_this);
        _this.handleMouseOut = _this.handleMouseOut.bind(_this);
        _this.handleOnly = _this.handleOnly.bind(_this);
        return _this;
    }
    LegacyMultiSelectListItem.prototype.getClassNames = function () {
        var _a;
        return classnames_1.default((_a = {
                "gd-list-item": true
            },
            _a["s-" + util_1.stringUtils.simplifyText(this.props.source.title)] = true,
            _a["has-only-visible"] = true,
            _a["is-selected"] = this.props.selected,
            _a));
    };
    LegacyMultiSelectListItem.prototype.renderOnly = function () {
        return (react_1.default.createElement("span", { className: "gd-list-item-only", onClick: this.handleOnly },
            react_1.default.createElement(react_intl_1.FormattedMessage, { id: "gs.list.only" })));
    };
    LegacyMultiSelectListItem.prototype.render = function () {
        return (react_1.default.createElement("div", { className: this.getClassNames(), onClick: this.handleSelect, onMouseOver: this.handleMouseOver, onMouseOut: this.handleMouseOut },
            react_1.default.createElement("label", { className: "input-checkbox-label" },
                react_1.default.createElement("input", { type: "checkbox", className: "input-checkbox", readOnly: true, checked: this.props.selected }),
                react_1.default.createElement("span", { className: "input-label-text" }, this.props.source.title)),
            this.renderOnly()));
    };
    LegacyMultiSelectListItem.defaultProps = {
        isLoading: false,
        onMouseOver: noop_1.default,
        onMouseOut: noop_1.default,
        onOnly: noop_1.default,
        onSelect: noop_1.default,
        selected: false,
        source: {},
    };
    return LegacyMultiSelectListItem;
}(react_1.PureComponent));
exports.LegacyMultiSelectListItem = LegacyMultiSelectListItem;
exports.default = react_intl_1.injectIntl(LegacyMultiSelectListItem);
//# sourceMappingURL=LegacyMultiSelectListItem.js.map